(() => {
  if (customElements.get('sm-free-shipping')) return;

  class SMFreeShipping extends HTMLElement {
    connectedCallback() {
      this.updateMessage();
      this.onLoad = () => this.updateMessage();
      window.addEventListener('load', this.onLoad, { once: true });
    }

    disconnectedCallback() {
      window.removeEventListener('load', this.onLoad);
    }

    updateMessage() {
      const total = Number(this.dataset.total);
      const currency = this.dataset.currency;
      const baseCurrency = this.dataset.baseCurrency;
      const lang = (this.dataset.language || 'en').split('-')[0];

      const messages = {
        de: {
          unlocked: '🎉 Du hast Gratisversand erreicht!',
          remaining: amount => `Noch ${amount} bis zum Gratisversand`
        },
        es: {
          unlocked: '🎉 ¡Has conseguido el envío gratuito!',
          remaining: amount => `Solo ${amount} más para envío gratuito`
        },
        en: {
          unlocked: "🎉 You've unlocked free shipping!",
          remaining: amount => `Only ${amount} left for free shipping`
        }
      };

      const text = messages[lang] || messages.en;

      if (baseCurrency !== 'EUR' || !Number.isFinite(total)) return;

      let rate = 1;

      if (currency !== 'EUR') {
        const shopifyCurrency = window.Shopify?.currency;
        if (shopifyCurrency?.active !== currency) return;

        rate = Number(shopifyCurrency.rate);
        if (!Number.isFinite(rate) || rate <= 0) return;
      }

      const baseThreshold = Number(this.dataset.threshold);
if (!Number.isFinite(baseThreshold) || baseThreshold <= 0) return;

const threshold = Math.ceil(baseThreshold * rate);
      const remaining = Math.max(0, threshold - total);
      const message = this.querySelector('[data-message]');
      const track = this.querySelector('[data-track]');
      const progress = this.querySelector('[data-progress]');

      if (!message || !track || !progress) return;

      if (remaining === 0) {
        message.textContent = text.unlocked;
        message.style.cssText =
          'margin:0;text-align:center;color:#2e7d32;font-weight:bold;';
        track.hidden = true;
        return;
      }

      let amount;

      try {
        amount = new Intl.NumberFormat(
          this.dataset.language || 'en',
          { style: 'currency', currency }
        ).format(remaining / 100);
      } catch {
        return;
      }

      message.textContent = text.remaining(amount);
      message.style.cssText = 'margin:0;font-size:13px;';
      progress.style.width =
        `${Math.min(100, Math.max(0, total / threshold * 100))}%`;
      track.hidden = false;
    }
  }

  customElements.define('sm-free-shipping', SMFreeShipping);
})();